module.exports = __webpack_public_path__ + "static/17-2-3e2ebc237d5261784601e9877dfac843.jpg";